const initialState = {
  loading: null,
  data: null,
  error: [null, null],
  filters: {
    offset: 0,
    limit: 999999999,
  },
};

export default initialState;
